// extracted by mini-css-extract-plugin
export default {"wrap":"Sw-z","fullWidth":"Tw-z","items":"Uw-z","featureCss":"Vw-z","disabled":"Ww-z","imgCss":"Xw-z"};